export const ADMIN_ROLE = "admin";

export const hasRole = (existingRoles: string[], neededRoles: string[]) => {
    return existingRoles && existingRoles.length && existingRoles.some((role) => neededRoles.includes(role));
};
